<bic-popup (close)="closeClicked()" [title]="finished ? 'Löschen abgeschlossen' : 'Dateien werden gelöscht'"
           customClass="w-[560px]">
  <div bicPopupContent class="flex flex-col gap-4">
    <!-- Gesamtstand zuerst: die Bloecke darunter zaehlen Ordner und Dateien GETRENNT, was neben der
         Badge in der App-Shell (die alles zusammen zaehlt) wie ein Widerspruch aussah. -->
    @if (totalCount > 0) {
      <div class="flex flex-col gap-1">
        <div class="flex items-center justify-between">
          <span class="text-sm font-medium text-gray-900">
            {{ settledCount }} von {{ totalCount }} Einträgen erledigt
          </span>
          <span class="text-xs text-gray-400">{{ overallProgress }}%</span>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-1.5 overflow-hidden">
          <div [style.width.%]="overallProgress"
               class="bg-green-500 h-1.5 rounded-full transition-all duration-300"></div>
        </div>
      </div>
    }

    <!-- Schritt 1: die Ordner selbst - übergeordnet über den Dateien, analog zum "Ordnerstruktur"-Block
         beim Upload. Sie werden erst gelöscht, wenn ihr Inhalt durch ist. -->
    @if (folders.length > 0) {
      <div class="flex flex-col gap-2 p-3 bg-white border border-gray-200 rounded-lg shadow-sm">
        <div class="flex items-center justify-between">
          <span class="text-xs font-medium text-gray-500">
            {{ deletedFolderCount }}/{{ folders.length }} Ordner gelöscht
          </span>
          <span class="text-xs text-gray-400">{{ folderProgress }}%</span>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-1.5 overflow-hidden">
          <div [style.width.%]="folderProgress"
               class="bg-green-500 h-1.5 rounded-full transition-all duration-300"></div>
        </div>
        <div [class.max-h-56]="showAllFolders" [class.overflow-y-auto]="showAllFolders"
             class="flex flex-col gap-2">
          @for (job of visibleFolders; track job.clientId) {
            <div class="flex items-center gap-2 text-xs">
              <fa-icon [icon]="faFolder" class="text-gray-400 w-3"></fa-icon>
              <span [title]="job.name" class="truncate flex-1 text-gray-600">{{ job.name }}</span>
              @switch (job.state) {
                @case ('error') {
                  <span class="text-red-500 flex-shrink-0">Fehler</span>
                }
                @case ('done') {
                  <fa-icon [icon]="faCircleCheck" class="text-green-500"></fa-icon>
                }
                @case ('deleting') {
                  <span class="text-gray-400 flex-shrink-0">läuft …</span>
                }
                @default {
                  <span class="text-gray-400 flex-shrink-0">wartet auf Inhalt …</span>
                }
              }
            </div>
          }
        </div>
        @if (folders.length > previewLimit) {
          <button class="text-xs text-gray-500 hover:text-gray-700 self-start" (click)="toggleShowAllFolders()">
            {{ showAllFolders ? 'Weniger anzeigen' : 'Alle anzeigen (' + folders.length + ')' }}
          </button>
        }
      </div>
    }

    <!-- Schritt 2: die Dateien einzeln - gleicher Aufbau wie bic-file-upload-progress. -->
    @if (files.length > 0) {
      <div class="flex flex-col gap-2 p-3 bg-white border border-gray-200 rounded-lg shadow-sm">
        <div class="flex items-center justify-between">
          <span class="text-xs font-medium text-gray-500">
            {{ deletedFileCount }}/{{ files.length }} gelöscht
          </span>
          <span class="text-xs text-gray-400">{{ fileProgress }}%</span>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-1.5 overflow-hidden">
          <div [style.width.%]="fileProgress"
               class="bg-green-500 h-1.5 rounded-full transition-all duration-300"></div>
        </div>
        <div [class.max-h-56]="showAllFiles" [class.overflow-y-auto]="showAllFiles"
             class="flex flex-col gap-2">
          @for (job of visibleFiles; track job.clientId) {
            <div class="flex items-center gap-2 text-xs">
              <fa-icon [icon]="job.state === 'error' ? faCircleExclamation : faFile"
                       class="text-gray-400 w-3"></fa-icon>
              <span [title]="job.name" class="truncate flex-1 text-gray-600">{{ job.name }}</span>
              @switch (job.state) {
                @case ('error') {
                  <span class="text-red-500 flex-shrink-0">Fehler</span>
                }
                @case ('done') {
                  @if (durationLabel(job)) {
                    <span class="text-gray-400 flex-shrink-0">{{ durationLabel(job) }}</span>
                  }
                  <fa-icon [icon]="faCircleCheck" class="text-green-500"></fa-icon>
                }
                @case ('deleting') {
                  <span class="text-gray-400 flex-shrink-0">läuft …</span>
                }
                @default {
                  <span class="text-gray-400 flex-shrink-0">wartet …</span>
                }
              }
            </div>
          }
        </div>
        @if (files.length > previewLimit) {
          <button class="text-xs text-gray-500 hover:text-gray-700 self-start" (click)="toggleShowAllFiles()">
            {{ showAllFiles ? 'Weniger anzeigen' : 'Alle anzeigen (' + files.length + ')' }}
          </button>
        }
      </div>
    }

    @if (failedCount > 0) {
      <span class="text-sm text-red-500">
        {{ failedCount }} {{ failedCount === 1 ? 'Eintrag' : 'Einträge' }} konnte{{ failedCount !== 1 ? 'n' : '' }} nicht gelöscht werden und
        {{ failedCount !== 1 ? 'bleiben' : 'bleibt' }} in der Liste.
      </span>
    }

    @if (!finished) {
      <span class="text-sm text-gray">
        Das Löschen läuft auf dem Server weiter, auch wenn Sie dieses Fenster schließen. Solange es
        läuft, kann die Datei nach einem Neuladen der Seite noch erscheinen.
      </span>
      @if (waitingSeconds >= 10) {
        <span class="text-sm text-gray">
          Der Server braucht dafür gerade ungewöhnlich lange.
        </span>
      }
    }
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end gap-4">
    <bic-button (onClick)="closeClicked()" [buttonType]="finished ? 'primary' : 'white'">
      {{ finished ? 'Schließen' : 'Im Hintergrund weiterlaufen lassen' }}
    </bic-button>
  </div>
</bic-popup>
